import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import es419 from '@/infra/i18n/translations/es-419.json'
import es from '@/infra/i18n/translations/es.json'
import ptBr from '@/infra/i18n/translations/pt-BR.json'
import ptPt from '@/infra/i18n/translations/pt-PT.json'

i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': {
      translation: ptBr
    },
    'pt-PT': {
      translation: ptPt
    },
    es: {
      translation: es
    },
    'es-419': {
      translation: es419
    }
  },
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  interpolation: {
    escapeValue: false
  }
})
